// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c7c94025/" + chunkId + "." + __webpack_require__.h() + ".vc7c94025.js";
};